import { render, staticRenderFns } from "./noticeOldManMc.vue?vue&type=template&id=55674308&scoped=true&"
import script from "./noticeOldManMc.vue?vue&type=script&lang=js&"
export * from "./noticeOldManMc.vue?vue&type=script&lang=js&"
import style0 from "./noticeOldManMc.vue?vue&type=style&index=0&id=55674308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55674308",
  null
  
)

export default component.exports